import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { queryClient } from 'providers';

const { getSendEmail } = TransectionApiServices();

export const useGetSendEmail = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return getSendEmail(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },

            onSuccess: (data: any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 1) {
                    message.success("Email has been send successfully")
                } else {
                    message.error(ResponseMessage);
                }

            },
        },
    );
};